export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ru": {
        "noFile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выберите файл"])}
      },
      "en": {
        "noFile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a file"])}
      }
    }
  })
}
